import React, { useState, useEffect } from 'react';
import { Table, Tag, Avatar, Space, Button } from 'antd';
import { StarOutlined, StarFilled } from '@ant-design/icons';
import CaseDrawer from './CaseDrawer';

const CaseTable = ({
  dataSource,
  columns,
  favorites = [],
  toggleFavorite = null,
  pagination = { pageSize: 10 },
  locale,
}) => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedCase, setSelectedCase] = useState(null);

  const handleRowClick = (record) => {
    setSelectedCase(record);
    setDrawerVisible(true);
  };

  // Keep the open drawer in sync with live data: when a background ingest job
  // completes and the case list refreshes with freshly generated thumbnails,
  // the drawer should reflect the new images without needing to be reopened.
  useEffect(() => {
    if (!drawerVisible || !selectedCase) return;
    const fresh = dataSource?.find((c) => c.key === selectedCase.key);
    if (fresh && fresh !== selectedCase) setSelectedCase(fresh);
  }, [dataSource, drawerVisible, selectedCase]);

  // Add the favorite star column if `toggleFavorite` is provided
  const enhancedColumns = toggleFavorite
    ? [
        {
          title: '',
          dataIndex: 'favorite',
          key: 'favorite',
          render: (_, record) => (
            <Button
              type="text"
              icon={
                favorites.includes(record.key) ? (
                  <StarFilled style={{ color: '#fadb14' }} />
                ) : (
                  <StarOutlined style={{ color: '#d9d9d9' }} />
                )
              }
              onClick={(e) => {
                e.stopPropagation(); // Prevent row click event from firing
                toggleFavorite(record.key);
              }}
            />
          ),
          width: 50,
        },
        ...columns,
      ]
    : columns;

  return (
    <>
      <Table
        dataSource={dataSource}
        columns={enhancedColumns}
        pagination={pagination}
        onRow={(record) => ({
          onClick: () => handleRowClick(record),
          style: { cursor: "pointer" },
        })}
        rowKey="key"
        locale={locale}
      />
      <CaseDrawer
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        selectedCase={selectedCase}
      />
    </>
  );
};

export default CaseTable;
